module.exports = __webpack_public_path__ + "static/media/share.888b5055.svg";